import axios from "axios";
import {
  STUDENT_SET_MCQ_LOADING,
  STUDENT_SET_MCQ_QUESTIONS,
  STUDENT_SET_MCQ_ERROR,
  STUDENT_SET_LESEN_LOADING,
  STUDENT_SET_LESEN_SUCCESS,
  STUDENT_SET_LESEN_ERROR,
  STUDENT_SET_AUDIO_LOADING,
  STUDENT_SET_AUDIO_SUCCESS,
  STUDENT_SET_AUDIO_ERROR,
  STUDENT_SET_STATUS_LOADING,
  STUDENT_SET_STATUS_SUCCESS,
  STUDENT_SET_STATUS_ERROR,
  STUDENT_SET_BUNDLE_LOADING,
  STUDENT_SET_BUNDLE_SUCCESS,
  STUDENT_SET_BUNDLE_ERROR,
} from "./types";

// MCQ
export const fetchStudentMcqQuestions = (page = 0) => async (dispatch) => {
  try {
    dispatch({ type: STUDENT_SET_MCQ_LOADING });
    const base = process.env.REACT_APP_API_URL || "";
    const { data } = await axios.get(`${base}/api/student/placement-questions/mcq`, { params: { page } });
    dispatch({ type: STUDENT_SET_MCQ_QUESTIONS, payload: data });
  } catch (err) {
    dispatch({ type: STUDENT_SET_MCQ_ERROR, payload: err?.response?.data?.message || err.message || "Failed to load MCQ" });
  }
};

// LESEN: passage + questions in one response
export const fetchStudentLesen = () => async (dispatch) => {
  try {
    dispatch({ type: STUDENT_SET_LESEN_LOADING });
    const base = process.env.REACT_APP_API_URL || "";
    const { data } = await axios.get(`${base}/api/student/placement-questions/lesen`);
    dispatch({ type: STUDENT_SET_LESEN_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: STUDENT_SET_LESEN_ERROR, payload: err?.response?.data?.message || err.message || "Failed to load Lesen" });
  }
};

// HÖREN: paged 20 per page
export const fetchStudentAudio = (page = 0) => async (dispatch) => {
  try {
    dispatch({ type: STUDENT_SET_AUDIO_LOADING });
    const base = process.env.REACT_APP_API_URL || "";
    const { data } = await axios.get(`${base}/api/student/placement-questions/audio`, { params: { page } });
    dispatch({ type: STUDENT_SET_AUDIO_SUCCESS, payload: data }); // Spring Page
  } catch (err) {
    dispatch({ type: STUDENT_SET_AUDIO_ERROR, payload: err?.response?.data?.message || err.message || "Failed to load Audio" });
  }
};


export const submitPlacementAnswers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const {
      mcq = {},
      lesen = {},
      audio = {},
      schreibenText = "",
    } = state.studentPlacementAnswers || {};

    const answers = [];

    const toNumberId = (k) => {
      const n = Number(k);
      return Number.isFinite(n) ? n : null;
    };

    const pushMap = (mapObj) => {
      Object.entries(mapObj).forEach(([qid, val]) => {
        const id = toNumberId(qid);
        if (id == null) return; // ignore any fallback temp keys
        answers.push({
          questionId: id,
          selectedOption: val?.text ?? null,
        });
      });
    };

    pushMap(mcq);
    pushMap(lesen);
    pushMap(audio);

    // 👇 Schreiben: send text WITHOUT questionId
    const trimmed = (schreibenText || "").trim();
    if (trimmed.length > 0) {
      answers.push({
        // questionId omitted on purpose
        writtenAnswer: trimmed,
      });
    }

    const base = process.env.REACT_APP_API_URL || "";
    const guestToken = localStorage.getItem("placementGuestToken");
    const { data } = guestToken
      ? await axios.post(`${base}/api/placement/guest/submit`, { answers }, { params: { token: guestToken } })
      : await axios.post(`${base}/api/student/placement-questions/submit`, { answers });

    return { ok: true, data };
  } catch (err) {
    return {
      ok: false,
      error: err?.response?.data?.message || err.message || "Submit failed",
    };
  }
};

// PLACEMENT STATUS
export const fetchPlacementTestStatus = (targetLevel) => async (dispatch) => {
  try {
    dispatch({ type: STUDENT_SET_STATUS_LOADING });
    const base = process.env.REACT_APP_API_URL || "";
    const guestToken = localStorage.getItem("placementGuestToken");
    const params = targetLevel ? { targetLevel } : {};
    const { data } = guestToken
      ? await axios.get(`${base}/api/placement/guest/status`, { params: { token: guestToken, ...params } })
      : await axios.get(`${base}/api/placement/monitor/test/status`, { params });
    // data shape: { hasSession, inProgress, submitted, blacklisted }
    dispatch({ type: STUDENT_SET_STATUS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: STUDENT_SET_STATUS_ERROR,
      payload: err?.response?.data?.message || err.message || "Failed to load placement status",
    });
  }
};

export const fetchStudentPlacementBundle = () => async (dispatch) => {
  try {
    dispatch({ type: STUDENT_SET_BUNDLE_LOADING });
    const base = process.env.REACT_APP_API_URL || "";
    const guestToken = localStorage.getItem("placementGuestToken");
    const { data } = guestToken
      ? await axios.get(`${base}/api/placement/guest/bundle`, { params: { token: guestToken } })
      : await axios.get(`${base}/api/student/placement-questions/bundle`);
    dispatch({ type: STUDENT_SET_BUNDLE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: STUDENT_SET_BUNDLE_ERROR,
      payload: err?.response?.data?.message || err.message || "Failed to load placement test",
    });
  }
};
